import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import { DataActionConditionType, CreateEventComposerSection } from 'cio/utils/campaigns/data-action';

interface BaseParsedAPIEventName {
  type: DataActionConditionType;
}

interface ParsedAPIEventNameTriggerAttribute extends BaseParsedAPIEventName {
  type: DataActionConditionType.TriggerAttribute;
  value: string;
}

interface ParsedAPIEventNameStatic extends BaseParsedAPIEventName {
  type: DataActionConditionType.Static;
  value: string;
}

export type ParsedAPIEventName = ParsedAPIEventNameTriggerAttribute | ParsedAPIEventNameStatic;

export default class CreateEventActionEventName implements CreateEventComposerSection {
  @tracked type: DataActionConditionType = DataActionConditionType.Static;
  @tracked value = '';

  originalType = DataActionConditionType.Static;
  originalValue = '';

  constructor(parsedEventName?: ParsedAPIEventName) {
    if (parsedEventName != null) {
      this.type = parsedEventName.type;
      this.value = parsedEventName.value;
    }

    this.originalType = this.type;
    this.originalValue = this.value;
  }

  static deserialize(event: string) {
    if (isEmpty(event)) {
      return new CreateEventActionEventName();
    }

    try {
      let parsedEventName = JSON.parse(event);
      return new CreateEventActionEventName(parsedEventName);
    } catch {
      // if parsing fails, it means the value is a simple string.
      return new CreateEventActionEventName({
        type: DataActionConditionType.Static,
        value: event,
      });
    }
  }

  serialize() {
    return JSON.stringify({
      type: this.type,
      value: this.value.trim(),
    });
  }

  get isDirty() {
    return this.type !== this.originalType || this.value !== this.originalValue;
  }

  get isValid() {
    return !isEmpty(this.value.trim());
  }
}
